import React from 'react';
import { STATUSES, useCustomToast } from 'shared/hooks/useCustomToast';
import { Text } from '@televet/kibble-ui';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalFooterButtons,
  ModalHeader,
} from '@televet/kibble-ui/build/components/Modal';
import { LoyaltyRewardAvailability, useUpdateLoyaltyProgramRewardMutation } from 'shared/types/graphql';

interface DeleteConfirmationModalProps {
  selectedRewardId?: string;
  isOpen: boolean;
  onClose: () => void;
  triggerRefetch: () => void;
}

export const DeleteConfirmationModal = ({
  selectedRewardId,
  isOpen,
  onClose,
  triggerRefetch,
}: DeleteConfirmationModalProps): JSX.Element => {
  const { toastMessagePop } = useCustomToast();
  const [deleteReward, { loading: isDeletingReward }] = useUpdateLoyaltyProgramRewardMutation();

  const handleDelete = async (): Promise<void> => {
    try {
      await deleteReward({
        variables: { where: { id: selectedRewardId }, data: { availability: LoyaltyRewardAvailability.Archived } },
      });
      toastMessagePop();
    } catch {
      toastMessagePop(
        'Whoops! There was a problem deleting this reward, please refresh the page and try again.',
        STATUSES.error,
      );
    } finally {
      triggerRefetch();
      onClose();
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalCloseButton />
      <ModalHeader>Are you sure you want to delete this reward?</ModalHeader>
      <ModalBody>
        <Text>Any pending rewards will be cancelled and the points will be refunded to the client.</Text>
      </ModalBody>
      <ModalFooterButtons
        onSubmit={handleDelete}
        isLoading={isDeletingReward}
        isDisabled={isDeletingReward}
        submitText="Delete"
        isDestructive
      />
    </Modal>
  );
};
